import PracticeAreasConstants from '../../../routes/PracticeAreasConstants';

import practiceAreaAviation from '../../../assets/Images/PracticeArea/Aviation/hero.svg';
import practiceAreaArbitration from '../../../assets/Images/PracticeArea/Arbitration/arbitrationHero.jpeg';
import practiceAreaBankingAndFinance from '../../../assets/Images/PracticeArea/BankingAndFinance/banking-and-finance-hero-image.jpeg';
import practiceAreaCompetition from '../../../assets/Images/PracticeArea/Competition/competitionHero.jpeg';
import practiceAreaConstruction from '../../../assets/Images/PracticeArea/BankingAndFinance/banking-and-finance-hero-image.jpeg';
import corporateHero from '../../../assets/Images/PracticeArea/Corporate/corporatehero.jpeg';
import CorporateGovernanceHero from '../../../assets/Images/PracticeArea/CorporateGovernance/CorporateGovernanceHero.jpeg';
import EmploymentHero from '../../../assets/Images/PracticeArea/Employment/EmploymentHero.jpeg';
import InsolvencyHero from '../../../assets/Images/PracticeArea/Insolvency/InsolvencyHero.jpeg';
import JoinVenturesHero from '../../../assets/Images/PracticeArea/JoinVentures/JoinVenturesHero.jpeg';
import LitigationHero from '../../../assets/Images/PracticeArea/Litigation/LitigationHero.jpeg';
import mergerAndAcquisitionHero from '../../../assets/Images/PracticeArea/MergerAndAcquisition/mergerAndAcquisitionHero.jpeg';
import practiceAreaOilAndGas from '../../../assets/Images/PracticeArea/OilAndGas/oil-gas-hero-image.jpeg';
import practiceAreaRealEstate from '../../../assets/Images/PracticeArea/RealEstate/real-estate-hero-image.jpeg';
import practiceAreaRenewableEnergy from '../../../assets/Images/PracticeArea/RenewableEnergy/renewableEnergyHero.jpeg';
import practiceAreaTechnology from '../../../assets/Images/PracticeArea/Technology/technology-hero-image.jpeg';
import practiceAreaTransportation from '../../../assets/Images/PracticeArea/Transportation/transportationHeroImage.png';
import WhiteCollarCrimeHero from '../../../assets/Images/PracticeArea/WhiteCollarCrime/WhiteCollarCrimeHero.jpeg';

export const PracticeAreaImages = [
  {
    img: practiceAreaArbitration,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.ARBITRATION,
  },
  {
    img: practiceAreaAviation,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.AVIATION,
  },
  {
    img: practiceAreaBankingAndFinance,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.BANKING_AND_FINANCE,
  },
  {
    img: practiceAreaCompetition,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.COMPETITION,
  },
  {
    img: practiceAreaConstruction,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.CONSTRUCTION,
  },
  {
    img: CorporateGovernanceHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.CORPORATE_GOVERNANCE,
  },
  {
    img: corporateHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.CORPORATE,
  },
  {
    img: EmploymentHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.EMPLOYMENT,
  },
  {
    img: practiceAreaRenewableEnergy,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.ENERGY,
  },
  {
    img: InsolvencyHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.InsolvencyHero,
  },
  {
    img: JoinVenturesHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.JOIN_VENTURES,
  },
  {
    img: LitigationHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.LITIGATION,
  },
  {
    img: mergerAndAcquisitionHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.MERGER_AND_ACQUISITION,
  },
  {
    img: practiceAreaOilAndGas,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.OIL_AND_GAS,
  },
  {
    img: practiceAreaRealEstate,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.REAL_ESTATE,
  },
  {
    img: practiceAreaRenewableEnergy,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.RENEWABLE_ENERGY,
  },
  {
    img: practiceAreaTechnology,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.TECHNOLOGY,
  },
  {
    img: practiceAreaTransportation,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.TRANSPORTATION,
  },
  {
    img: WhiteCollarCrimeHero,
    title: 'Adaptions',
    textLines: [
      'Arbitration',
      'Adaptions in Arbitration',
      'Rules',
      '31 January, 2024',
    ],
    toPage: PracticeAreasConstants.WHITE_COLLAR_CRIME,
  },
];
